import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AbstractWidgetComponent, ContextChange, DialogService, MasterDetailListEntry, ResponseMessage, ResponseStatus, TranslationService, UserProfileDialogService, WidgetStyle } from '@sdbn/common';

import { TransportMessage, TransportMessageDetails } from '../message-administration.model';
import { MessageAdministrationService } from '../message-administration.service';

@Component({
  selector: 'app-message-administration',
  templateUrl: './message-administration.component.html',
  styleUrls: ['./message-administration.component.scss']
})
export class MessageAdministrationComponent extends AbstractWidgetComponent implements OnInit {

  messages: TransportMessage[] = [];

  selected: TransportMessage;
  //selectedDetails = new TransportMessageDetails();
  workingCopyDetails = new TransportMessageDetails();

  responseMessages: ResponseMessage[];
  isLoading = false;
  detailsFormGroup = new FormGroup({
    name: new FormControl('', [Validators.required])
  });


  get cancelEnabled() {
    return !this.isLoading && this.detailsFormGroup.dirty;
  }

  get saveEnabled() {
    const longMessage = this.workingCopyDetails.messageLong.values.find(v => v.language === 'de' && v.value != null && v.value.length > 0);
    const shortMessage = this.workingCopyDetails.messageShort.values.find(v => v.language === 'de' && v.value != null && v.value.length > 0);
    return this.detailsFormGroup.dirty && this.detailsFormGroup.valid && longMessage != null && shortMessage != null;
  }

  get sendEnabled() {
    const longMessage = this.workingCopyDetails.messageLong.values.find(v => v.language === 'de' && v.value != null && v.value.length > 0);
    const shortMessage = this.workingCopyDetails.messageShort.values.find(v => v.language === 'de' && v.value != null && v.value.length > 0);
    return (this.workingCopyDetails?.id != null && this.workingCopyDetails?.id > 0) && this.detailsFormGroup.valid && longMessage != null && shortMessage != null;
  }

  constructor(
    private messageAdministrationService: MessageAdministrationService,
    private dialog: MatDialog,
    public translationService: TranslationService,
    public userProfileDialogService: UserProfileDialogService,
    private dialogService: DialogService
  ) {
    super();
    //this.selectedDetails = this.createEmptyDetails();
    this.workingCopyDetails = this.createEmptyDetails();
    this.initializeDetailsForm();
  }

  ngOnInit() {
    this.load();
  }

  private initializeDetailsForm() {
    this.detailsFormGroup

    this.detailsFormGroup.valueChanges.subscribe(
      values => {
        if (this.detailsFormGroup.dirty) {
          this.workingCopyDetails.name = this.detailsFormGroup.controls.name.value;
        }
      }
    );
  }

  setSelected(message: TransportMessage) {

    if (this.selected != null && this.selected.id === message.id) {
      return;
    }

    if (this.workingCopyDetails != null && this.detailsFormGroup.dirty) {

      this.dialogService.showConfirm(
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.title',
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.setSelectedWithoutCheck(message);
      });


    } else {
      this.setSelectedWithoutCheck(message);
    }

  }

  setSelectedWithoutCheck(message: TransportMessage) {
    this.selected = message;
    this.isLoading = true;
    this.responseMessages = [];

    this.messageAdministrationService.getTransportMessageDetails({ id: message.id }).subscribe(details => {
      if (details != null) {
        //this.selectedDetails = new TransportMessageDetails(details);
        this.workingCopyDetails = new TransportMessageDetails(details);
        this.resteFormValues();
      } else {
        this.clear();
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  delete(message: TransportMessage) {

    this.responseMessages = [];


    this.dialogService.showConfirm(
      'tmc-yard.ui.admin.message-administration.delete.confirm-dialog.title',
      'tmc-yard.ui.admin.message-administration.delete.confirm-dialog.message'
    ).afterClosed().subscribe(() => {
      this.isLoading = true;

      this.messageAdministrationService.deleteTransportMessage({ id: message.id }).subscribe(response => {
        if (response.status === ResponseStatus.SUCCESS) {
          this.clearAndLoad();
        } else {
          this.responseMessages = response.responseMessages;
        }
        this.isLoading = false;
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
    });
  }

  load() {
    this.isLoading = true;
    this.responseMessages = [];
    this.messageAdministrationService.getTransportMessages().subscribe(messages => {

      this.messages = new Array<TransportMessage>();
      for (const m of messages) {
        this.messages.push(new TransportMessage(m));
      }

      if (this.messages.length > 0) {
        if (this.selected == null) {
          this.setSelectedWithoutCheck(this.messages[0]);
        } else {
          const oldSelected = this.messages.find(s => s.id === this.selected.id);
          if (oldSelected != null) {
            this.setSelectedWithoutCheck(oldSelected);
          } else {
            this.setSelectedWithoutCheck(this.messages[0]);
          }
        }
      }

      this.isLoading = false;
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  addNew() {
    if (this.workingCopyDetails != null && this.detailsFormGroup.dirty) {

      this.dialogService.showConfirm(
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.title',
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.clear();
      });

    } else {
      this.clear();
    }
  }

  cancel() {
    if (this.workingCopyDetails != null && this.detailsFormGroup.dirty) {

      this.dialogService.showConfirm(
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.title',
        'tmc-yard.ui.admin.message-administration.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.discardChanges();
      });
    } else {
      this.discardChanges();
    }
  }

  discardChanges() {
    this.responseMessages = [];
    if (this.workingCopyDetails.id === -1) {
      this.clear();
    } else {
      this.setSelectedWithoutCheck(this.selected);
    }
  }

  private clear() {
    this.responseMessages = [];
    this.selected = null;

    // this.selectedDetails = this.createEmptyDetails();
    // this.workingCopyDetails = new TransportMessageDetails((this.selectedDetails));
    this.workingCopyDetails = this.createEmptyDetails();
    this.resteFormValues();
  }

  private createEmptyDetails(): TransportMessageDetails {
    const details = new TransportMessageDetails();
    details.id = -1;
    return details;
  }

  clearAndLoad() {
    this.clear();
    this.load();
  }

  public save() {
    this.isLoading = true;
    this.responseMessages = [];

    this.messageAdministrationService.saveTransportMessage(this.workingCopyDetails).subscribe(response => {
      this.isLoading = false;
      if (response.status === ResponseStatus.SUCCESS) {
        this.workingCopyDetails = new TransportMessageDetails(this.workingCopyDetails);
        this.load();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.isLoading = false;
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.setSelected(entry as TransportMessage);
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.addNew();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    this.delete(entry as TransportMessage);
  }

  public onDictionaryChanged() {
    this.detailsFormGroup.markAsDirty();
  }

  public sendMessage() {
    this.responseMessages = [];


    this.dialogService.showConfirm(
      'tmc-yard.ui.admin.message-administration.message-details.send.confirm-dialog.title',
      'tmc-yard.ui.admin.message-administration.message-details.send.confirm-dialog.message'
    ).afterClosed().subscribe(() => {
      this.isLoading = true;
      this.messageAdministrationService.sendTransportMessage({ id: this.workingCopyDetails.id }).subscribe(response => {
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
    });


  }

  private resteFormValues() {
    const values: any = {};
    if (this.workingCopyDetails != null) {
      values.name = this.workingCopyDetails.name;
    } else {
      values.name = null;
    }
    this.detailsFormGroup.reset(values);
    this.detailsFormGroup.markAsPristine();
    this.detailsFormGroup.markAsUntouched();
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
